import { render, staticRenderFns } from "./OrderAccountTable.vue?vue&type=template&id=2a4c1858&scoped=true&"
import script from "./OrderAccountTable.vue?vue&type=script&lang=js&"
export * from "./OrderAccountTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4c1858",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
